function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n            &,\n            &:hover,\n            &:active {\n                background: ",
        ";\n                color: ",
        ";\n                cursor: default;\n            }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n            &:disabled {\n                ",
        "\n            }\n\n            ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    background: ",
        ";\n    color: ",
        ";\n\n    ",
        "\n\n    &:active {\n        background: ",
        ";\n        color: ",
        ";\n    }\n\n    ",
        "\n\n    &:focus-visible {\n        outline: none;\n        box-shadow: 0px 0px 0px ",
        " ",
        ";\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                ",
        ";\n                // We should hard-code height to ensure that the button\n                // is a consistent height with or without an icon\n                height: ",
        ";\n                min-height: ",
        ";\n                padding: ",
        " ",
        ";\n                border-radius: ",
        ";\n                gap: ",
        ";\n\n                svg {\n                    height: ",
        ";\n                    width: ",
        ";\n                }\n            "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n                ",
        ";\n                // See above note re: height\n                height: ",
        ";\n                min-height: ",
        ";\n                padding: ",
        " ",
        ";\n                border-radius: ",
        ";\n                gap: ",
        ";\n\n                svg {\n                    height: ",
        ";\n                    width: ",
        ";\n                }\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    &:active:enabled {\n        transform: scale3d(0.94, 0.94, 1);\n    }\n\n    transition: background-color 50ms ease, color 50ms ease, transform 50ms ease,\n        border-radius 50ms ease;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    flex: ",
        ";\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    box-sizing: border-box;\n\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n\n        ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnhandledError } from "@internal/errors";
import { ellipsis, rem } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import { hover } from "../css/hover";
import { Base } from "../palette/base";
import { semanticColor } from "../palette/semantic";
import { globalCtaLarge, globalCtaSmall } from "../typography";
export * from "./Button.styles";
var Button = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var className = props.className, variant = props.variant, text = props.text, iconLeft = props.iconLeft, iconRight = props.iconRight, size = props.size, fill = props.fill, blend = props.blend, btnProps = _objectWithoutProperties(props, [
        "className",
        "variant",
        "text",
        "iconLeft",
        "iconRight",
        "size",
        "fill",
        "blend"
    ]);
    return /*#__PURE__*/ _jsxs(ButtonStyled, _objectSpread({
        type: "button",
        className: className,
        variant: variant,
        ref: ref,
        $size: size,
        $fill: fill,
        blend: blend
    }, btnProps, {
        children: [
            iconLeft,
            text && /*#__PURE__*/ _jsx(TextContainer, {
                children: text
            }),
            iconRight
        ]
    }));
});
export { Button };
export var buttonVariantStyles = function(variant, blend, disabled) {
    return css(_templateObject2(), blend ? "none" : semanticColor("action-".concat(variant, "-bg")), semanticColor("action-".concat(variant, "-fg")), hover("\n        background: ".concat(semanticColor("action-".concat(variant, "-bg--hover")), ";\n        color: ").concat(semanticColor("action-".concat(variant, "-fg--hover")), ";\n    ")), semanticColor("action-".concat(variant, "-bg--pressed")), semanticColor("action-".concat(variant, "-fg--pressed")), function() {
        var disabledStyles = css(_templateObject(), semanticColor("action-".concat(variant, "-bg--disabled")), semanticColor("action-".concat(variant, "-fg--disabled")));
        return css(_templateObject1(), disabledStyles, disabled && disabledStyles);
    }, rem(variant === "primary" ? 3 : 1), Base.Positive100);
};
export var buttonSizeStyles = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "medium";
    switch(size){
        case "small":
            return css(_templateObject3(), globalCtaSmall, rem(34), rem(34), rem(8.5), rem(12), rem(8), rem(6), rem(16), rem(16));
        case "medium":
            return css(_templateObject4(), globalCtaLarge, rem(48), rem(48), rem(12), rem(16), rem(12), rem(8), rem(20), rem(20));
        default:
            throw new UnhandledError(size);
    }
};
export var buttonTransitionStyles = css(_templateObject5());
export var baseButtonStyles = function(param) {
    var variant = param.variant, fill = param.fill, _blend = param.blend, blend = _blend === void 0 ? false : _blend, disabled = param.disabled;
    return css(_templateObject6(), ellipsis(), fill ? 1 : null, buttonVariantStyles(variant, blend, disabled));
};
var ButtonStyled = styled.button.withConfig({
    componentId: "sc-b59fd49c-0"
})(_templateObject8(), function(props) {
    return css(_templateObject7(), baseButtonStyles({
        variant: props.variant,
        fill: props.$fill,
        blend: props.blend
    }), buttonSizeStyles(props.$size));
}, buttonTransitionStyles);
export var TextContainer = styled.span.withConfig({
    componentId: "sc-b59fd49c-1"
})(_templateObject9(), ellipsis());
